import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=fdb146ba&scoped=true&"
import script from "./Booking.vue?vue&type=script&lang=js&"
export * from "./Booking.vue?vue&type=script&lang=js&"
import style0 from "./Booking.vue?vue&type=style&index=0&id=fdb146ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb146ba",
  null
  
)

component.options.__file = "Booking.vue"
export default component.exports